<template>
  <div class="setup">
    <v-form v-if="show">
      <v-text-field
        v-model="setup.name"
        label="Name"
        solo
        dense
      ></v-text-field>

      <v-text-field
        v-if="!isType('Icon')"
        v-model="setup.value"
        label="Value"
        solo
        dense
      ></v-text-field>

      <app-iconselector v-model="setup.value" v-if="isType('Icon')">
        <template v-slot="{ on }">
          <v-btn class="mb-5" color="primary" block v-on="on">Add Icon</v-btn>
        </template>
      </app-iconselector>

      <div class="text-right">
        <v-btn type="submit" fab x-small color="primary"
          @click.prevent="submit">
          <v-icon v-if="!setup.guid">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
        </v-btn>
      </div>
    </v-form>

    <v-divider class="my-5"></v-divider>

    <ul class="setup__list" v-if="show">
      <li
        v-for="s in setups"
        :key="s.guid"
      >
        <div
          class="setup__item d-flex align-center justify-space-between"
          :class="{ 'c-pointer': isType('Scope') }"
          @click="select(s)"
        >
          <div class="setup__details">
            <v-badge dot left offset-y="8" color="success" :value="isSelected(s.guid)">
              <p class="mb-0 subtitle-2">{{ s.name }}</p>
            </v-badge>
            <p class="mb-0 caption grey--text">{{ s.value }}</p>
          </div>

          <div class="setup__action">
            <app-delete :item="s" @confirm="removeSetup(s)">
              <template v-slot="{ on }">
                <v-btn color="primary" fab x-small @click.stop="on.click">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </app-delete>
          </div>
        </div>
      </li>
      <li class="setup__item--empty caption grey--text" v-if="!setups.length">
        No items of type {{ type }}
      </li>
    </ul>
  </div>
</template>

<script>
import { Setup } from '@/api';
import { assign, get } from 'lodash';

export default {
  name: 'setup-form',
  props: {
    nameLabel: { type: String, default: 'Name' },
    valueLabel: { type: String, default: 'Value' },
    selected: { type: Object, default: () => ({}) },
    show: Boolean,
    scope: String,
    type: String,
  },
  data() {
    return {
      setup: { },
      setups: [],
      params: [],
      icons: [],
      dialog: false,
    };
  },
  watch: {
    selected() {
      if (this.type.match('Param')) {
        this.setup = {};
        this.fetchSetups(true);
      }
    },
  },
  methods: {
    submit() {
      if (!this.setup.guid) this.saveSetup();
      else this.updateSetup();
    },
    select(s) {
      if (s === this.setup) {
        this.setup = {};
        this.$emit('select', {});
      } else {
        this.setup = s;
        this.$emit('select', s);
      }
    },
    async saveSetup() {
      const params = { type: this.type };
      this.$store.commit('START_LOADING');
      try {
        if (this.isType('Param')) assign(params, { org: this.selected.guid });
        await Setup.create(this.scope, assign(this.setup, params));
        await this.fetchSetups();
        this.setup = { };
      } catch (err) { console.debug(err); }
      this.$store.commit('END_LOADING');
    },
    async updateSetup() {
      this.$store.commit('START_LOADING');
      try {
        await Setup.update(this.setup);
        await this.fetchSetups();
        this.setup = { };
      } catch (err) { console.debug(err); }
      this.$store.commit('END_LOADING');
    },
    async fetchSetups(progress) {
      const params = { type: this.type, guid: this.scope };
      if (progress) this.$store.commit('START_LOADING');
      try {
        if (this.isType('Param')) assign(params, { org: this.selected.guid });
        const { data } = await Setup.fetch(params);
        this.setups = data;
      } catch (err) { console.debug(err); }
      if (progress) this.$store.commit('END_LOADING');
    },
    async removeSetup(setup) {
      this.$store.commit('START_LOADING');
      try {
        await Setup.delete(this.scope, setup.guid);
        await this.fetchSetups();
        this.$emit('delete');
      } catch (err) { console.debug(err); }
      this.$store.commit('END_LOADING');
    },
    isSelected(guid) {
      return get(this.setup, 'guid') === guid;
    },
    isType(type) {
      return this.type === type;
    },
  },
  mounted() {
    if (this.show) this.fetchSetups(true);
  },
};
</script>
